import { PostFieldsFragment } from '@/src/generated/graphql';
import { renderToStaticMarkup } from 'react-dom/server';
import { RelatedPostsInBody, PostItem } from '@components';

const genAnchor = (i: number) => `<!-- 関連リンク${i} -->`;

type RelatedPosts =
  | PostFieldsFragment['hnaviRelatedPosts1']
  | PostFieldsFragment['hnaviRelatedPosts2'];

const toPostItems = (pp: NonNullable<RelatedPosts>): PostItem[] =>
  [
    { imgSrc: pp.image1?.sourceUrl, href: pp.href1, label: pp.label1 },
    { imgSrc: pp.image2?.sourceUrl, href: pp.href2, label: pp.label2 },
    { imgSrc: pp.image3?.sourceUrl, href: pp.href3, label: pp.label3 },
  ].filter((e): e is PostItem => !!(e.imgSrc && e.href && e.label));

const insertRelatedPosts = (
  src: string,
  relatedPosts: RelatedPosts,
  anchor: string
) => {
  if (!relatedPosts) {
    return src;
  }
  const postItems = toPostItems(relatedPosts);
  if (postItems.length === 0) {
    return src;
  }
  return src.replace(
    anchor,
    renderToStaticMarkup(
      <RelatedPostsInBody
        postItems={postItems}
        heading={relatedPosts.heading}
        bgColor={relatedPosts.bgColor}
      />
    )
  );
};

export const insertAllRelatedPosts = (
  src: string,
  relatedPostsList: RelatedPosts[]
) =>
  relatedPostsList.reduce(
    (acc, cur, i) => insertRelatedPosts(acc, cur, genAnchor(i + 1)),
    src
  );
